import { useEffect, useState } from "react";
import { getCaptchaConfig } from "../api/application";

const useCaptcha = () => {
  const [captchaConfig, setCaptchaConfig] = useState(null);
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaProvider, setCaptchaProvider] = useState("");

  useEffect(() => {
    getCaptchaConfig().then((response) => {
      if (response.data) {
        setCaptchaConfig(response.data);
      }
    });
  }, []);

  const onVerify = (token, provider) => {
    setCaptchaToken(token);
    setCaptchaProvider(provider);
  };

  const onExpire = () => {
    setCaptchaToken("");
    setCaptchaProvider("");
  };

  return { captchaConfig, captchaToken, captchaProvider, onVerify, onExpire };
};

export default useCaptcha;
